"use client";

type ErrorStateProps = {
  description: string;
  label: string;
  onRetry?: () => void;
  retryLabel: string;
  title: string;
};

export function ErrorState({
  description,
  label,
  onRetry,
  retryLabel,
  title,
}: ErrorStateProps) {
  return (
    <section className="feedback-card">
      <span className="feedback-pill feedback-pill--warning">{label}</span>
      <h1>{title}</h1>
      <p>{description}</p>
      {onRetry ? (
        <button className="feedback-button" onClick={onRetry} type="button">
          {retryLabel}
        </button>
      ) : null}
    </section>
  );
}
